"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "getDocument", {
  enumerable: true,
  get: function get() {
    return _pdfjsDist.getDocument;
  }
});

var _pdfjsDist = require("pdfjs-dist");

_pdfjsDist.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(_pdfjsDist.version, "/pdf.worker.min.js");
